import type { SectionTab } from 'v2/shared/components/section-tabs'

export type WhatsAppTab = 'numbers' | 'templates'

export const WHATSAPP_TAB_COPY: Record<WhatsAppTab, SectionTab> = {
  numbers: { title: 'Numbers', description: 'Manage WhatsApp-enabled business numbers.' },
  templates: {
    title: 'Templates',
    description: 'Create and manage WhatsApp message templates.',
  },
}
